import { t } from '@i18n';
import { org_sector_type_enum } from '@predium/enums';
import { NAVIGATION_ICONS } from '../../assets/icons';
import { PATHS } from '../../routes';
import {
  ConsumptionInvoicesTabEnum,
  DataCollectionEnergySuppliersTabEnum,
  StatusQuoAnalysisTabEnum,
} from '../../routes/search_params/searchParamsEnums';
import { NavItem } from './type';

export type GlobalSearchConfigProps = NavItem[];
const ESG_ANALYSIS_BENCHMARK_ENTIRE_COMPANY_ID = -1;

export const getGlobalSearchConfig = (
  isEconomicUnitsToggled: boolean,
  isReportingToggled: boolean,
  isAdmin: boolean,
  cbiEnabled: boolean,
  orgSector: org_sector_type_enum,
): GlobalSearchConfigProps => {
  return [
    {
      title: t('General_DataCollection'),
      path: PATHS.dataCollection.root(),
      icon: NAVIGATION_ICONS.DATA_COLLECTION,
    },
    {
      title: t('General_BuildingAnalysis'),
      path: PATHS.statusQuoAnalysis.buildings({
        tab: StatusQuoAnalysisTabEnum.DEMAND,
        benchmark: ESG_ANALYSIS_BENCHMARK_ENTIRE_COMPANY_ID,
      }),
      icon: NAVIGATION_ICONS.BUILDING_ANALYSIS,
    },
    {
      title: t('General_PortfolioAnalysis'),
      path: PATHS.statusQuoAnalysis.portfolio({
        tab: StatusQuoAnalysisTabEnum.DEMAND,
        benchmark: ESG_ANALYSIS_BENCHMARK_ENTIRE_COMPANY_ID,
      }),
      icon: NAVIGATION_ICONS.PORTFOLIO_ANALYSIS,
    },
    ...(isEconomicUnitsToggled
      ? [
          {
            title: t('General_EconomicUnitsAnalysis', { orgSector }),
            path: PATHS.statusQuoAnalysis.economicUnits({
              tab: StatusQuoAnalysisTabEnum.DEMAND,
              benchmark: ESG_ANALYSIS_BENCHMARK_ENTIRE_COMPANY_ID,
            }),
            icon: NAVIGATION_ICONS.ECONOMIC_UNITS,
          },
        ]
      : []),
    {
      title: t('General_ActionPlanning'),
      path: PATHS.actionPlanning.scenarios(),
      icon: NAVIGATION_ICONS.ACTION_PLANNING,
    },
    ...(isReportingToggled
      ? [
          {
            title: t('General_Reporting'),
            path: PATHS.reporting.root(),
            icon: NAVIGATION_ICONS.REPORTING,
          },
        ]
      : []),
    {
      title: t('DataCollection_EnergySupplier', { count: 2 }),
      path: PATHS.dataCollection.energySuppliers({ tab: DataCollectionEnergySuppliersTabEnum.ALL }),
      icon: NAVIGATION_ICONS.ENERGY_SUPPLIERS,
    },
    ...(cbiEnabled
      ? [
          {
            title: t('General_ConsumptionInvoices'),
            path: PATHS.dataCollection.consumptionInvoices({ tab: ConsumptionInvoicesTabEnum.PROCESSING }),
            icon: NAVIGATION_ICONS.CONSUMPTION_INVOICES,
          },
        ]
      : []),
    ...(isAdmin
      ? [
          {
            title: t('Settings_ManageOrganization'),
            path: PATHS.org.settings(),
            icon: NAVIGATION_ICONS.ORG_SETTINGS,
          },
          {
            title: t('General_ManagePortfolios'),
            path: PATHS.dataCollection.portfolios(),
            icon: NAVIGATION_ICONS.PORTFOLIO_MANAGEMENT,
          },
          {
            title: t('PageName_ManageUsers'),
            path: PATHS.org.users(),
            icon: NAVIGATION_ICONS.USERS,
          },
        ]
      : []),
  ];
};
